/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DeviceRegistrationRequestDTO = {
  /**
   * Account number associated with the device
   */
  accountNumber?: string;
  /**
   * Version of the application
   */
  appVersion?: string;
  /**
   * Channel through which the device is registered
   */
  channel?: DeviceRegistrationRequestDTO.channel;
  /**
   * Fingerprint of the device
   */
  deviceFingerprint?: string;
  /**
   * Unique identifier for the device
   */
  deviceId: string;
  /**
   * Model of the device
   */
  deviceModel?: string;
  /**
   * Name of the device
   */
  deviceName?: string;
  /**
   * IP address of the device
   */
  ipAddress?: string;
  /**
   * Operating system of the device
   */
  osVersion?: string;
  /**
   * User agent string of the device
   */
  userAgent?: string;
  /**
   * Unique identifier for the user associated with the device
   */
  userId?: string;
};

export namespace DeviceRegistrationRequestDTO {
  /**
   * Channel through which the device is registered
   */
  export enum channel {
    WEB = "WEB",
    MOBILE = "MOBILE",
    POS = "POS",
  }
}
